import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import FormHelper from '../../form.js';
import ModalRegisterContractor from '../../../../master/contractor/helper/component/Modal.js';
import SelectQuery from '../../../../component/SelectQuery.js';


export default class ModalStartWork extends React.Component {
	constructor() {
		super();
		this.inistialState = {
			Alias: '',
		  Contractor: '',
      modalMode: null,
		  modalRegisterContractor: false, 	
		}
		this.state = this.inistialState
		this.openModalContractor  = this.openModalContractor.bind(this)
		this.closeModalContractor = this.closeModalContractor.bind(this)
		this.reset = this.reset.bind(this)
	}

	generateLabel(MasterReducer, type) {
		let OptionAutoComplete = [];
		for(let i = 0 ; i < MasterReducer.length; i++) {
		  OptionAutoComplete.push(
		    { value: MasterReducer[i].Alias, label: MasterReducer[i].Name }
		  )
		}
		return OptionAutoComplete
	}

	openModalContractor(mode) {
	  this.setState({
	    modalMode: mode,
	    modalRegisterContractor : true,
	  })
	}

	closeModalContractor() {
	  this.setState({modalRegisterContractor : false})
	}

	onStartWork() {
		if(!FormHelper.ValidateFormStartWork(this.state)) {
		  return
		}
		this.props.onStartWork({
			Alias : this.state.Alias,
			Contractor : this.state.Contractor
		})
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ Alias : nextProps.work.alias })
	}

	reset() {
		this.setState({
			Contractor: ''
		})
	}

	render() {
		const props = this.props;

		return (
			<div>
				<Modal isOpen={props.modalStartWork} onExit={()=>this.reset()} toggle={()=>props.closeModal()}>
					<ModalHeader toggle={()=>props.closeModal()}>Start Work</ModalHeader>
					<ModalBody>
						<div className="row">
							<div className="form-group col-sm-12">
								<label className="required">Contractor</label>
									<div className="float-right">
										<button 
											type="button" style={{ fontSize : 12 }} 
											className="btn btn-sm btn-primary" 
											onClick={() => this.openModalContractor("modal_add")} 
											>
												<i className="fa fa-plus-square"></i>
										</button>
									</div>
								<SelectQuery 
								name="Contractor"
								placeholder="Contractor"
								value={this.state.Contractor}
								urlKey="read-contractor-autocomplete"
								valKey="Alias"
								valLabel="Name"
								onChange={(val) => this.setState({Contractor: val.value})}
								UserReducer={this.props.UserReducer}
								/>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={()=>props.closeModal()}>Cancel</Button>
						<Button color="primary" onClick={()=>this.onStartWork()}>Start</Button>
					</ModalFooter>

				</Modal>
				<ModalRegisterContractor 
					isModal  = {this.state.modalRegisterContractor}
					open     = {this.openModalContractor}
					close    = {this.closeModalContractor}
					mode     = {this.state.modalMode}
					data     = {""}
					onSuccess= {() => undefined}
					onFailed = {() => undefined}
					is_process={this.state.is_process}
					UserReducer={this.props.UserReducer}
				/>
			</div>
		);
  }
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/Modal/ModalStartWork.js